import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Icon from "@/components/UI/Icon.vue";
import {computed, ref} from "vue";
type Theme = 'light' | 'dark';

export default /*@__PURE__*/_defineComponent({
  __name: 'CloseButton',
  props: {
  theme: {
    type: String as () => Theme,
    default: 'dark'
  }
},
  setup(__props) {




const iconColor = computed(() => {
  return __props.theme === 'light' ? '#FFFFFF' : '#363739';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["back-button", [__props.theme]])
  }, [
    _createVNode(Icon, {
      name: "close",
      size: 12,
      color: iconColor.value
    }, null, 8, ["color"])
  ], 2))
}
}

})